import React from 'react';
import './styes/FooterPages.css';

const Refund: React.FC = () => {
  return (
    <div className="footer-page">
      <h1>Returns, Replacements & Refund Policy</h1>
      
      <section>
        <h2>Returns and replacements</h2>
        <p>
          Returns or replacements are accepted only in very limited cases and are always subject to our quality verification.
        </p>
        <ul>
          <li><strong>Immediate deliveries (same‑day / quick deliveries):</strong> You must raise a return/replacement request within 24 hours from the time of delivery.</li>
          <li><strong>Scheduled deliveries (slot‑based / next‑day deliveries):</strong> You must raise a return/replacement request within 12 hours from the time of delivery.</li>
        </ul>
        
        <h3>A return or replacement request will be considered only if:</h3>
        <ul>
          <li>The product is damaged in transit at the time of delivery, or</li>
          <li>The product is missing (short quantity) as compared to the invoice, or</li>
          <li>The product delivered is different from what was ordered (wrong product, grade, size, brand, or specification).</li>
        </ul>
        
        <p><strong>Change‑of‑mind returns are not accepted.</strong></p>
        <p>
          All such requests must include order details and clear photos/videos showing the damage, shortage or mismatch.
        </p>
      </section>

      <section>
        <h2>Quality verification (QA) before approval</h2>
        <p>
          Every return or replacement request goes through BuildZap's internal quality and logistics verification process.
        </p>
        <ul>
          <li>Our team may conduct a physical inspection at site, request additional photos/videos, or arrange pickup of the material for inspection.</li>
          <li>Only if the issue is confirmed by our QA checks (damage, missing quantity, or wrong item as compared to the order) will the return/replacement be approved and the refund or replacement processed.</li>
          <li>If QA verification does not confirm the reported issue, the return/replacement request may be rejected and the goods will be treated as successfully delivered.</li>
        </ul>
      </section>

      <section>
        <h2>Refund process and timelines</h2>
        <p>
          Once a cancellation, return or replacement request is approved after QA verification:
        </p>
        <ul>
          <li><strong>Refund initiation:</strong> BuildZap will initiate the refund on the same day the issue is approved and closed by our support/logistics/QA team.</li>
          <li><strong>Credit timeline:</strong> The amount is usually processed and reflected in your original payment method or designated bank account within 5–7 business days, depending on banks and payment gateways.</li>
        </ul>
        <p>
          Where clearly offered and accepted, you may opt to receive the approved refund as store credit instead of a transfer to your payment method.
        </p>
      </section>

      <p className="last-updated">
        <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}
      </p>
    </div>
  );
};

export default Refund;
